import * as React from "react";

const SvgKeyboardArrowUp = ({ color, size }) => (
  <svg
    viewBox="0 0 25 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m7.91 15.41 4.59-4.58 4.59 4.58L18.5 14l-6-6-6 6 1.41 1.41z"
      fill={color}
    />
  </svg>
);

export default SvgKeyboardArrowUp;
